import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IPropertyChatModel } from '../models/PropertyChatModel';
import { PropertyRentTermModel } from '../models/ComparePropertyDetailModel';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  selectedExchange = new BehaviorSubject<number>(0);
  exchangeSelection = this.selectedExchange.asObservable();
  changeSelectedExchange(value: number) {
    localStorage.setItem('selectedExchangeId', value.toString());
    this.selectedExchange.next(value);
  }
  setExchange(value: number) {
    localStorage.setItem('selectedExchangeId', value.toString());
  }


  get GetselectedExchangeId() {
    return localStorage.getItem('selectedExchangeId');
  }

  RemoveSelectedExchangeId() {
    localStorage.removeItem('selectedExchangeId');
  }

  OfferDetail = new BehaviorSubject<boolean>(false);
  offerPageReloadStatus = this.OfferDetail.asObservable();
  reloadOfferDetail(value: boolean) {
    this.OfferDetail.next(value);
  }

  propertyCardDiv = new BehaviorSubject<number>(0);
  propertyCardDivId = this.propertyCardDiv.asObservable();
  highlightPropertyCard(value: number) {
    this.propertyCardDiv.next(value);
  }

  resetValue = new BehaviorSubject<boolean>(false);
  resetValueClicked = this.resetValue.asObservable();
  resetClicked(value: boolean) {
    this.resetValue.next(value);
  }

  filterValue = new BehaviorSubject<boolean>(false);
  filterValueClicked = this.filterValue.asObservable();
  FilterClicked(value: boolean) {
    this.filterValue.next(value);
  }

  favouriteValue = new BehaviorSubject<boolean>(false);
  favouriteValueClicked = this.favouriteValue.asObservable();
  clickFavourite(value: boolean) {
    this.favouriteValue.next(value);
  }

  dislikeValue = new BehaviorSubject<boolean>(false);
  dislikeValueClicked = this.dislikeValue.asObservable();
  clickDislike(value: boolean) {
    this.dislikeValue.next(value);
  }

  messageValue = new BehaviorSubject<IPropertyChatModel>(null);
  messageValueClicked = this.messageValue.asObservable();
  clickMessage(value: IPropertyChatModel) {
    this.messageValue.next(value);
  }

  notificationCount = new BehaviorSubject<boolean>(false);
  notificationCountClicked = this.notificationCount.asObservable();
  clickReadNotification(value: boolean) {
    this.notificationCount.next(value);
  }

  revisionValue = new BehaviorSubject<number>(0);
  revisionClicked = this.revisionValue.asObservable();
  addRevision(value: number) {
    this.revisionValue.next(value);
  }

  propertyRentTerm = new BehaviorSubject<PropertyRentTermModel[]>([]);
  propertyRentTermTable = this.propertyRentTerm.asObservable();

  setPropertyRentTermValue(rentterm: PropertyRentTermModel[]) {
    this.propertyRentTerm.next(rentterm);
  }

  portfolioProperties = new BehaviorSubject<any[]>([])
  portfolioPropertiesChange = this.portfolioProperties.asObservable();

  setPortfolioProperties(data: any[]) {
    this.portfolioProperties.next(data);
  }

  refreshMessage = new BehaviorSubject<boolean>(false)
  refreshMessageChange = this.refreshMessage.asObservable();

  setrefreshMessage(data: boolean) {
    this.refreshMessage.next(data);
  }

  reloadFinancialSummary = new BehaviorSubject<number>(0)
  financialSummaryChange = this.reloadFinancialSummary.asObservable();

  setReloadFinancialSummary(data: number) {
    this.reloadFinancialSummary.next(data);
  }
}
